import { PathCode, PathName } from "../enum/path-type.enum";

export enum Product {
  ME = 'ME',
}

export interface ProductInfo {
  code: Product;
  label: string;
  logo: string;
  name: string;
  codes: PathCode[];
}


const productInfoMap: ProductInfo[] = [
  // No need logo for this product
  {
    code: Product.ME,
    label: 'Mobilité éco-active',
    logo: '',
    name: PathName.MOBILITE_ECO_ACTIVE,
    codes: [PathCode.MEA],
  }
];

export const getProductInfo = (
  productCode: string,
): ProductInfo | undefined => {
  return productInfoMap.find((productInfo) => productInfo.code === productCode);
};

export function getImgPlafond(productCode: string, brand: string): string {
  return 'assets/common/{0}/popup-info/plafonds{1}.png'.replace('{0}', brand).replace('{1}', productCode);
}

export function getProductFromCode(code: string): ProductInfo | undefined {
  const productInfo = productInfoMap.find((product) => product.codes.includes(code as PathCode));
  return productInfo ? productInfo : undefined;
}
